import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import axios from "axios";
import $ from 'jquery';
import './panel.css';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js';
import { mode } from "d3"
// import stripe from 'stripe';
import {Elements} from '@stripe/react-stripe-js';
// import {loadStripe} from '@stripe/stripe-js';


var descriptor = {};
var origDescriptor = null;

var stripe = null;


function px(v) { return v + 'px'; }
function pc(v) { if (v < 0) v = 0; if (v > 100) v = 100; return Math.round(v) + '%'; }
function val(v) { v = parseFloat(v); if (isNaN(v)) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring(o) { return typeof (o) == 'string'; }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return o instanceof Object; }
function isnumber(o) { return typeof (o) == 'number' && !isNaN(o); }
function defined(o) { return typeof (o) != 'undefined'; }
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec() { return new Date().getTime(); }
function getsec() { return Math.round(getmsec() / 1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig, '').toLowerCase() }
function iarray(v, n) {
    var ret = [];
    for (var i = 0; i < n; i++)
        ret.push(v instanceof Object ? clone(v) : v);
    return ret;
}


let company = null;

let resources = [
    {key:'users', label:'Users'},
    {key:'datasets', label:'Datasets'},
    {key:'dataset_items', label:'Dataset Items'},
    {key:'projects', label:'Projects'},
    {key:'tasks', label:'Project Tasks'},
    {key:'models', label:'Models'},
    {key:'model_runs', label:'Model Runs'},
    
]

let planDesc = [ 
    {key:'name', label:'', th: true},
    {key:'sprice', label:'Price'},
    ...resources,
    {key:'singleSignon', label:'Single Sign On'},
    {key:'privateInstance', label:'Private Instance'},
    {key:'managedWorkforce', label:'Managed Workforce'},
    {key:'button', label:''}
]

function CompanyEdit(prop) {
    
    var elements = null;

    let companyFields = ['newname', 'registername', 'domain', 'billingContactName', 'billingContactEmail', 'billingContactPhone'];

    function editCompany( company, add )
	{
		var origCompany = clone(company);
		company.newname = company.name;

	    function cb(ev)
	    {
			frm.removeInlineErrors() // added 19/1 mani
			let err = false;
			if( !company.newname || !company.newname.trim() ) { 
				setTimeout( function(){frm.inlineError( $('#newname'), 'Company Name is required')}, 200 )
				err = true; 
			}
			if( !company.domain || !company.domain.trim() ) { 
				setTimeout( function(){frm.inlineError( $('#domain'), 'Company E-mail Domain is required')}, 200 )
				err = true; 
			}
			if( err ) {
				ev.preventDefault();
				ev.stopPropagation();
				return false;
			}
			var updateData = {
				_new: add || false,
				_id: company._id,
				priv: company.priv,
                name: company.newname,
				active: company.active ? true : false,
			};
            for( let f of companyFields ) updateData[f] = company[f] || '';
			console.log( 'UPDATE_COMPANY', updateData );
	        window.post( 'update_company', {company:updateData}, function(res){
	            console.log( 'UPDATE USERx', res )
				if (res.data.status) {
                    // window.goPage( window.GlobalVars.companyBackPage || '')
                    window.GlobalVars.userCurrentRole.companyName = res.data.name
                    window.saveSession();
					setTimeout(function () { document.location.reload(); }, 200);
				}
				else {
					// alert( res.data.value );
					frm.myAlert('Update Error', res.data.value);
				}
	        });
			return false;
	    }
		if( Date.now() > company.resetTimeout ) company.resetPassword = null;

        function changed()
		{
		}

		var btnName = add ? 'Add Company' : 'Save';
		var title = add ? 'Add New Company' : 'Edit Company';
        $('#savebtn').html(btnName)
        $('#pageTitle').html(title)
        if( !add && window.GlobalVars.userPriv.admin ) {
            $('#delbtn').show();
        }

        $('#savebtn').off('click').on('click', cb );
        $('#delbtn').off('click').on('click', async (ev) => {
            if( await frm.myConfirm( 'Delete Company', 'Are you sure you want to delete this company? This will remove the company and all Datasets, Dataset Items, Projects and Tasks related to the deleted company. This operation cannot be undone.', 'delete company and all related data', 'Delete Company', 'Cancel') ) {
                company.active = false;
                cb(ev)
            }
        } );


		companyFields.forEach( n =>
		{
			$('.maincontent').find('#'+n).val( company[n] ).on('change', function(){
				var id = $(this).prop('id');
				var val = $(this).val();
				console.log( 'change', id, val );
				company[id] = val;
				changed();
			})
		})
		var focus = $('#name');

		var companyPrivs = frm.arr2Bool(company.priv.split(','));
		var privItems = {};
		var allPrivs = clone(window.privs); delete allPrivs.admin;
		for( var p in allPrivs ) privItems[p] = { default: false, label: window.privs[p] };
		console.log( 'companyPrivs', companyPrivs, 'privItems', privItems );
		frm.booleanList( $('#companyPrivs'), companyPrivs, {
			items: privItems,
			header: ['',''],
			callbackOnInit: false,
		}, function(o){
			var npriv = [];
			for( var p in o ) if(o[p]) npriv.push(p);
			company.priv = npriv.join(',');
			console.log( 'privs', o, company.priv );
			changed();
		} );
	    return false;
	}

    async function stripeCheckout( plan, code ) {
        $('#currentplan').html('')
        await frm.myAlertClose();
        frm.loading('please wait');
        console.log('codex', code)
        console.log( 'stripeCheckout', plan )
        // debugger;
        let pr = window.getParams();
        pr.plan = plan.id;
        let sdata = (await window.post('payment_checkout', {
            priceId: code,
            pageParams: pr,
            metadata: {
                companyName: company.name,
                company: company._id,
                plan: plan.id,
                priceId: code,
            }
        })).data;
        window.location = sdata.url;
        console.log( 'payment_checkout', sdata )
    }

    async function stripeAccount() {
        let pr = window.getParams();
        console.log( 'COMPANY', company._id )
        let sdata = (await window.post('payment_account', {
            company: company._id,
            pageParams: pr,
        })).data;
        if( !sdata.status ) return frm.myAlert('Account Details', sdata.value )
        console.log( 'DATA', sdata )
        window.location = sdata.url;
    }

    async function goTicket( plan ) {
        let a = $('<a target="_new" href="https://tensoractinc.freshdesk.com/support/home">');
        $(document.body).append(a);
        a[0].click();
        setTimeout( function(){
            a.remove();
        })
    }

    async function ticketAlert(msg, subscriptionType) {
        const textarea = $('<textarea>');
        textarea.attr('id', 'myTextarea');
        textarea.attr('name', 'myTextarea');
        textarea.attr('class', 'form-control');
        textarea.attr('placeholder', 'Enter your message');
        textarea.prop('required',true);
        textarea.attr('rows', '4');
        textarea.attr('cols', '50');
        
        let result;
        return frm.myAlert('Create ticket', textarea, 'Submit ticket', async function(ev){
            ev.preventDefault();
            ev.stopPropagation();

            if( !textarea.val() ) return frm.inlineError( textarea, 'Enter your message' );

            result = await createTicket(msg);

            await frm.myAlertClose();

            //result returns response 201
            if (result.status !== 201) return frm.myAlert('Failed', 'Please try again', 'Ok');
            
            if(subscriptionType == 'upgrade') return frm.myAlert('Ticket Created', 'Your request for a subscription upgrade has been received. Our Sales team will contact you soon.', 'Ok' );

            if(subscriptionType == 'downgrade') return frm.myAlert('Ticket Created', 'Your request for a subscription downgrade has been received. Our Sales team will contact you soon.', 'Ok' );
        }, 'Cancel');
    }

    async function chargedPlan( plan ) {
        console.log('planx', plan)
        await frm.myAlertClose();

        if( company.plan == plan.id ) frm.myAlert( 'Change Plan', 'Your current plan is already <b>'+company.planData.name+'</b>.')
        if( company.plan && company.planData.type == 'enterprise' && window.GlobalVars.userCurrentRole.priv .includes("c_admin") ) {
            if (window.enable_freshdesk_apikey) {
                ticketAlert('Request for a subscription downgrade', 'downgrade')
            }
            else {
                return frm.myAlert('Freshdesk API key required', 'Kindly enable freshdesk API key from the System Config page to create support ticket.', 'Ok' );
            }
        }

        frm.myAlert(plan.name, '<div id="selectplan"></div>', '', null, 'Cancel' )
        $('.modal-dialog').css({maxWidth: 1024})
        $('#modal-close').hide();
        $('#selectplan').html(`
        <div class="row">
            <div class="col-4">
            <label>Billing Contact</label>
                <input placeholder="Billing Contact Name" type="text" id="billingContactName" class="mb-4 form-control" />
                <input placeholder="Billing Contact Email" type="text" id="billingContactEmail" class="mb-4 form-control" />
                <input placeholder="Billing Contact Phone Number" type="text" id="billingContactPhone" class="mb-4 form-control" />
            </div>
            <div class="col-8">
            <center><label>Select payment option</label></center>
                <table id="planprices" class="tableplanprice"></table>
            </div>            
        </div>
`)
        let inputs = Array.from( $('#selectplan').find('input'));
        console.log('inputex', inputs)
        for (let inpt of inputs) {
            $(inpt).val($('#' + inpt.id).val())
            $(inpt).on('change', function(ev) {
                let id = this.id;
                $('#'+id).val( $(this).val() )
            })
        }
        frm.inputTitles();
        
        let tr = $('<tr>');
        $('#planprices').append( tr);
        let prices = plan.prices.filter( p => p.active );
        for( let pr of prices ) {
            let td = $('<td>')
            .html(pr.label + '<br><b>' + pr.amount + '</b><br><i>' + pr.description + '</i>')
            .addClass(pr.label)
            .css({width:(100/prices.length)+'%'})
            .prop('code', pr.id )
            .on('click', updateBilling )
            tr.append( td );
        }
        $('#planprices')

        async function updateBilling() {
            var updateData = {
				_id: company._id,
                active: true,
			};
            let inpterr = false;
            frm.removeInlineErrors();
            for (let inpt of inputs) {
                company[inpt.id] = updateData[inpt.id] = $(inpt).val().trim();
                if( !updateData[inpt.id] ) inpterr = frm.inlineError( $(inpt), 'Enter ' + inpt.placeholder )
            }
            if( inpterr ) return;
            console.log('UPTATE', updateData, $(this).prop('code') )
            // debugger;
            frm.loading('Please wait')
	        await window.post( 'update_company', {company:updateData} )
            stripeCheckout( plan, $(this).prop('code') );
        }
        // stripeCheckout( c );
    }

    async function setPlan(key, confirm) {
        console.log('plan', key)
        frm.myAlertClose();
        frm.loading('please wait');
        let cres = (await window.post('company_choose_plan', { company: company._id, plan: key, confirm: confirm })).data;
        if (!cres.status) {
            frm.loadingOut();
            if (window.enable_freshdesk_apikey) {
                if (key.match(/enterprise/)) {
                    ticketAlert('Request for a subscription upgrade', 'upgrade')
                }
                else {
                    ticketAlert('Request for a subscription downgrade', 'downgrade')
                }
            }
            else {
                frm.myAlert('Freshdesk API key required', 'Kindly enable freshdesk API key from the System Config page to create support ticket.', 'Ok');
            }
            // frm.loadingOut(); 
        }
        else {
            let params = window.getParams();
            if (params.plan) {
                delete params.plan;
                delete params.confirm;
                window.goPage('companyedit', params)
            }
            else document.location.reload();
        }
    }


    async function selectPlan() {
        frm.loading('');
        let cplans = (await window.post('company_plans', {})).data;
        console.log( 'cplans', cplans )
        frm.loadingOut();
        frm.myAlert('Select Plan', '<div id="selectplan"></div>', '', null, 'Cancel' )
        $('.modal-dialog').css({maxWidth: 1024})
        $('#modal-close').hide();
        let plans = $('<table class="tableplans">');
        $('#selectplan').append( plans );

        for( let p of planDesc ) {
            var tr = $('<tr>');
            tr.append($('<td>').html(p.label));
            let tag = p.th ? '<th>' : '<td>';
            for( let c of cplans ) {
                if( !c.active ) continue;
                if( p.key == 'button') {
                    let but = $('<button class="btn btn-primary">').html('Select')
                    but.on('click', async function(ev) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        if( c.type == 'charged' ) { 
                            return chargedPlan( c );
                        }
                        else {
                            await frm.myAlertClose();
                            setPlan( c.id );
                        }
                    })
                    console.log( 'PPPPPPPPPPP', c.id, company.plan )
                    tr.append($(tag).append(but));
                    if( c.id == company.plan ) {
                        but.html('Selected');
                        but.attr('disabled', true)
                    }
                    continue;
                }
                let v = c[p.key];
                if( v == -1 ) v = 'unlimited';
                else if( v === true ) v = 'yes';
                else if( v === false ) v = 'no';
                tr.append($(tag).html(v));
            }
            plans.append( tr )
        }

    }

    async function showPlan() {
        let cusage = (await window.post('company_usage', {company:company._id})).data;
        console.log( 'cusage', cusage );
        let changePlan = $('<button class="btn btn-primary ml-2">Change plan</button>').on('click', selectPlan )
        let planData = '<div class="current-plan-content-header">' + company.planData.name + '</div>';
        if( company.planData.price_detail ) {
            planData += '<div>' + company.planData.price_detail + '</div>';
        }
        if( company.planData.expire ) planData += '<div>Valid: ' + tabler.formatDate(company.planData.expire*1000) + '</div>';
        if( company.planData.canceled ) planData += '<div class="current-plan-canceled">Renewal canceled</div>';
        $('#currentplan').html('Current plan: <div class="current-plan" style="cursor: default;"><div class="current-plan-content">' + planData + '<div></div>' ).append(changePlan);
        console.log('xpx', company.planData.name)
        if(company.planData.name == "Professional") { $('.current-plan-content').append('<div><span style="color:#007bff; text-decoration: underline; text-underline-offset: 2px; cursor:pointer;">edit</span></div>') }
        $('#rightcol').show()

        $('.current-plan').off('click');
        if( company.planData.price_detail ) {
            $('.current-plan').off('click').on('click', stripeAccount );
        }

        var desc = {
            title: '',
            columns: {
                name: 'Resource',
                quota: 'Limit',
                used: 'Used',
                status: 'Status',
            },
            filter: false,
            search: false,
            sort: false,
            // initialSort: 'name',
            // initialSortDir: -1,
            pageSize: 10,
            noFilter: null,
            noSearch: null,
            noSort: null,
            centerCol: ['quota', 'used', 'status'],
            formatCol: {
            },
            forceType: {
                used: 1,
            },
        }
        var tabused = tabler.table($('#tabusage'), desc, null);

        for( let r of resources ) {
            let quota = company.planData[r.key];
            let used = cusage[r.key];
            console.log('quotax', quota, used)
            let status = '';
            if( used == quota ) status = '<span class="error">limit reached</span>';
            if( used > quota )status = '<span class="error">exeeded</span>';
            if( quota == -1 ) {
                quota = 'unlimited';
                status = '';
            }
            tabused.addRow({
                name: r.label,
                quota: quota,
                used: used,
                status: status,
            })
        }
        tabused.draw()
    }

    async function paymentHistory() {
        let phist = (await window.post('get_payments', {company:company._id})).data;

        console.log( 'phist', phist );
        var desc = {
            title: '&nbsp;',
            columns: {
                timestamp: 'Date',
                amount: 'Amount',
                status: 'Status',
            },
            filter: false,
            search: false,
            sort: false,
            initialSort: 'timestamp',
            initialSortDir: -1,
            pageSize: 10,
            noFilter: null,
            noSearch: null,
            noSort: null,
            centerCol: ['status'],
            formatCol: {
                timestamp: function(d) { return tabler.formatDate(d*1000) },
                amount: function(v) { return (v/100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });},
            },
            forceType: {
                timestamp: 1,
            },
        }
        var tabpay = tabler.table($('#tabpay'), desc, null);

        if(phist.records){

        for( let p of phist.records ) {
            if( !p.type.match(/payment/)) continue;
            let status = '<span class="payment_succeeded">Paid</span>';
            if( p.type == 'payment_failed') status = '<span class="payment_failed">Failed</span>';
            else if( p.type == 'payment_chargeback') status = '<span class="payment_chargeback">Chargeback</span>';
            else if( p.type == 'payment_disputed') status = '<span class="payment_disputed">Disputed</span>';
            let a = {
                timestamp: p.timestamp,
                status: status,
                amount: p.amount,
            };
            console.log( 'tabpay', a )
            tabpay.addRow(a)
        }
        }
        tabpay.draw()

        if( phist.processed ) {
            let params = window.getParams();
            if( params.plan ) {
                delete params.plan;
                delete params.confirm;
                window.goPage('companyedit', params )
            }
            else  document.location.reload();
            return;
        }

        if( company.plan ) {
            await showPlan();
        }
    }

    async function initCompany() {
        $('#rightcol').hide()
        // const key = "pk_test_51LYviWSDSAcuQj6RmUjLutrJOAAoBVrH2tZYOyAL2y3M9tJw00XUoJ4SWnI13VZ0SN5X9V2Cuv1Ln9vYQMSgaf7J001U8ldRGz"
        // stripe = await loadStripe(key)

        company = { active: true, priv: '' };
        let add = 1;
        window.topBarVisible()
        let params = window.getParams();
        if (params.company == 'new') {
            company.priv = Object.keys(window.privs).filter(v => v != 'admin').join(',')
        }
        else {
            if (!params.company) params.company = window.GlobalVars.userCurrentRole.company;
            let res = await window.post('find_companies', { match: { _id: params.company } })
            company = res.data.records[0];
            window.company = company;
            add = 0;
        }


        editCompany(company, add);
        // if( params.confirm ) {
        //     $('#currentplan').html('')
        //     setPlan( params.plan, params.confirm)
        // }
        // $('#paybtn').on('click', (ev) => {
        //     payModal( company );
        // })
        frm.inputTitles();
        paymentHistory();

    }

    const createTicket = async (title) => {

        const userEmail = window.GlobalVars.userEmail;
        const freshdeskAPIkey = window.freshdesk_apikey;

        const description = $('#myTextarea').val();
        
        try {
            const response = await axios.post(
                "https://tensoractinc.freshdesk.com/api/v2/tickets",
                {
                  email: userEmail,
                  phone: "",
                  description: description,
                  subject: title,
                  type: "Feature Request",
                  priority: 4,
                  status: 3,
                  source: 2,
                  cc_emails: [userEmail, "support@tensoract.com"],
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                  auth: {
                    username: freshdeskAPIkey,
                  },
                }
              );
            
              const result = await response.data;
            
              console.log('ticket res', JSON.stringify(result));
                return response;

        } catch (error) {
            console.log('erox res', error.response)
            console.log('erox', error)
            return error.response
        }
      };

    useEffect(function (a) {
        initCompany();
    });

    useEffect(() => {
        setTimeout(async() => {
            let planData, priceId;
            let {tier, plan} = window.GlobalVars.userMetadata || {};
            console.log('tierandplan', tier, plan)

            let executeStripe = async()=>{
                let plans = await (window.post('company_plans', {}));
                console.log('planex', plans)

                planData = await plans.data.find(plan => plan.id == tier )
                console.log('useffect plan', planData)

                for(let priceid of planData.prices){
                    if(priceid.label == plan) {
                        priceId = priceid.id
                    }
                }
                console.log('pidx', priceId)

                if(tier == planData.id) {
                    window.GlobalVars.userMetadata = {}
                    window.company.newname = 
                    await window.saveSession();
                    await window.post('user_acknowledge', {metadata:{ tier, plan }} )
                    stripeCheckout(planData, priceId)
                }
            }
            executeStripe();            
        }, 2000);

    }, [])
    

    return (
        <div fluid="md p-0" className="maincontent">
            <div className="row">
                <div className="wizzbtn">
                    <Button id="savebtn" variant="primary" type="button" className="ml-3 btn btn-primary"><i class=" mr-2 fa fa-floppy-o"></i> Save</Button>
                    <Button id="delbtn" variant="danger" type="button" className="ml-2 mr-3 btn btn-danger hidden"><i className="fa fa-trash-o mr-2"></i> Delete Company</Button>
                </div>
                <div className="col-5">
                    <div className="project-panel">
                        <div className="step2 type-Classification">
                            <div className="project-section">
                                <button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
                                    <h1>Settings</h1><i className="fa fa-chevron-down acc"></i></button>
                                <div id="collapse1" className="collapse show" aria-labelledby="headingEight" >
                                    <div id="companydetails">
                                        <label htmlFor="name">Company Name</label>
                                        <input placeholder="Company Name" type="text" id="newname" className="mb-4 form-control" />
                                        <input placeholder="Business Legal Name" type="text" id="registername" className="mb-4 form-control" />
                                        <input placeholder="Company email Domain" type="text" id="domain" className="mb-4 form-control" />
                                        <div id="companyActive"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="step2 type-Classification">
                            <div className="project-section">
                                <button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapse2" aria-expanded="true" aria-controls="collapse2">
                                    <h1>Roles</h1><i className="fa fa-chevron-down acc"></i></button>
                                <div id="collapse2" className="collapse show" aria-labelledby="headingEight" >
                                    <div id="companyPrivs">privs</div>
                                </div></div>
                        </div>

                    </div>
                </div>
                <div className="col-7">
                    <div id="rightcol" className="project-panel">
                        <div className="step2 type-Classification">
                        <div className="project-section">
                                <button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseusage" aria-expanded="true" aria-controls="collapse20">
                                    <h1>Usage/Plan</h1><i className="fa fa-chevron-down acc"></i></button>
                                <div id="collapseusage" className="collapse show" aria-labelledby="headingEight" >
                                    <div id="currentplan" className="mb-2"></div>
                                    <table id="tabusage"></table>
                                </div>
                            </div>
                        </div>

                        <div className="step2 type-Classification">
                            <div className="project-section">
                                <button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapse3" aria-expanded="false" aria-controls="collapse2">
                                    <h1>Billing Contact</h1><i className="fa fa-chevron-down acc"></i></button>
                                <div id="collapse3" className="collapse" aria-labelledby="headingEight" >
                                    <input placeholder="Billing Contact Name" type="text" id="billingContactName" className="mb-4 form-control" />
                                    <input placeholder="Billing Contact Email" type="text" id="billingContactEmail" className="mb-4 form-control" />
                                    <input placeholder="Billing Contact Phone Number" type="text" id="billingContactPhone" className="mb-4 form-control" />
                                    <div className="payment" id="payment"></div>
                                </div>
                            </div>
                        </div>

                        <div className="step2 type-Classification">
                        <div className="project-section">
                                <button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapsepayhist" aria-expanded="true" aria-controls="collapse20">
                                    <h1>Payment History</h1><i className="fa fa-chevron-down acc"></i></button>
                                <div id="collapsepayhist" className="collapse show" aria-labelledby="headingEight" >
                                    <table id="tabpay"></table>
                                </div>
                            </div>
                        </div>                        

                    </div>
                </div>
            </div>
        </div>
    )
    }

var defaultCustomNerTestPayload = {
    "text": {
        "1": "This is a text by Michael Smith",
        "2": "A paper from Oxford University"
    }
};

export default CompanyEdit;
